<template>
    <div class="description">
        <div class="control-width mx-auto">
            <div class="p-4 p-md-5 border shadow-sm add-rounded">
                <h4 class="mb-3 font-weight-bold kova-text">Provide project description below</h4>
                <h6 class="mb-3 font-weight-bold text-left mt-4">Project name</h6>

                    <a-input size="large" placeholder="e.g. Build me web application" class="mx-auto mb-3"/>   
                    <!-- <a-textarea size="large" placeholder="Project description" class="mx-auto mt-2" :autosize="{ minRows: 4, maxRows: 8 }"/> -->
                    <vue-editor id="editor" useCustomImageHandler @image-added="handleImageAdded" v-model="htmlForEditor" placeholder="Project Descriptions..."></vue-editor>

                <div class="container-fluid px-0 px-md-4 mb-5 mt-4">
                    <div class="row">
                        <div class="col text-left">
                            <button class="btn-outline-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="goBack"> Back </button>
                        </div>
                        <div class="col text-right">
                            <button class="btn-kovatek py-2 px-4 px-sm-5 btn-rounded" v-on:click="next">Next </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-right kova-text pt-3 mr-4">
                <span @click="skip">Skip <font-awesome-icon icon="step-forward"></font-awesome-icon></span>
            </div>
        </div>
        
        
 </div>
</template>
<script>

import { VueEditor } from "vue2-editor";

export default {
    name: 'description',
    components: {
        VueEditor
    },
    data(){
        return {
            htmlForEditor: ""
        }
    },
    methods: {
        goBack(){
            this.$router.go(-1)
        },
        next(){
            this.$router.push({path:'stack'})
        },
        skip(){
            this.$router.push({path:'stack'})
        },
        handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
        
            var formData = new FormData();
            formData.append("file", file);
        
            this.$http({
                url: "https://fakeapi.yoursite.com/images",
                method: "POST",
                data: formData
            })
            .then(result => {
            let url = result.data.url; // Get url from response
            Editor.insertEmbed(cursorLocation, "file", url);
            resetUploader();
            })
            // .catch(err => {
            // console.log(err);
            // });
        }
    }
}
</script>
<style scoped>
.control-width{
    width: 600px;
}

@media (min-width: 768px) and (max-width: 991px){
   
}
@media (max-width: 767px){
    .control-width{
        width:500px;
    }
}
@media (max-width: 550px){
    .control-width{
        width:98%;
    }
}
</style>